import * as Yup from 'yup';

import { globalMessages } from '@savgroup-front-common/core/helpers';

const IssuesPageSchema = Yup.object().shape({
  choiceIssue: Yup.string().required(globalMessages.form.required),
});

export default IssuesPageSchema;
